import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { OrderConfirmed as OrderConfirmedContent } from '@hero/components/organisms';
import { RECOGNITION_STATUSES } from '@hero/constants';
import { PageLayout } from '@hero/layouts';
import { ROUTE_PATHS } from '@hero/routes';
import { useGetRecognition } from '@hero/services';

function OrderConfirmed() {
  const { recognitionCode } = useParams();
  const { data } = useGetRecognition({ recognitionCode });
  const { t } = useTranslation();
  const navigate = useNavigate();

  const isRecognition = window?.location.pathname.includes('recognition');
  const orderType = isRecognition ? t('oneTimeGift') : t('automation');

  return (
    <PageLayout
      header={{
        title: t('orderReceived', { featureType: orderType }),
        subtitle: data?.status?.current === RECOGNITION_STATUSES.starting && (
          <Trans
            i18nKey="orderTypeOrderSubtitle"
            values={{ orderType: orderType.toLowerCase(), strong: <strong /> }}
          />
        )
      }}
      navigation={{
        leftButton: {
          children: t('goToOneTimeGifts'),
          onClick: () => navigate(ROUTE_PATHS.MY_RECOGNITIONS)
        }
      }}
    >
      <OrderConfirmedContent id={recognitionCode} data={data} />
    </PageLayout>
  );
}

export { OrderConfirmed };
